import type { DuePaymentMethod } from '@zetyar/domain'

export function formatMoney(amount: number, currency: string): string {
  try {
    return new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency,
      maximumFractionDigits: currency === 'CLP' ? 0 : 2,
    }).format(amount)
  } catch {
    return `${amount.toLocaleString('es-CL')} ${currency}`
  }
}

export const PAYMENT_METHOD_LABELS: Record<DuePaymentMethod, string> = {
  transfer: 'Transferencia',
  cash: 'Efectivo',
  other: 'Otro',
  mercadopago: 'Mercado Pago',
}

export const FIELD_CLASS =
  'h-11 w-full rounded-[13px] border border-neutral-200 bg-white px-3.5 text-sm text-neutral-900 focus:outline-none focus:ring-2 focus:ring-primary-500/20 dark:border-neutral-800 dark:bg-neutral-900 dark:text-neutral-100'

export const TEXTAREA_CLASS =
  'min-h-20 w-full rounded-[13px] border border-neutral-200 bg-white px-3.5 py-2.5 text-sm text-neutral-900 focus:outline-none focus:ring-2 focus:ring-primary-500/20 dark:border-neutral-800 dark:bg-neutral-900 dark:text-neutral-100'

// Stable codes raised by the dues RPCs (0033) and the create-due-preference Edge Function.
const DUES_ERROR_MESSAGES: Record<string, string> = {
  dues_forbidden: 'Tu rol no permite realizar esta acción en Cuotas.',
  dues_not_configured: 'La tesorería aún no configura las cuotas de esta organización.',
  dues_period_taken: 'Alguno de los meses seleccionados ya está pagado, exento o con un pago en proceso.',
  dues_invalid_months: 'La cantidad de meses debe estar entre 1 y 24.',
  dues_invalid_period: 'El mes seleccionado no es válido.',
  dues_invalid_method: 'Método de pago no válido.',
  dues_membership_not_found: 'El socio no está activo en esta organización.',
  dues_payment_not_found: 'No encontramos ese pago.',
  dues_payment_not_revertible: 'Este pago ya no se puede revertir.',
  dues_gateway_payment_not_revertible:
    'Los pagos en línea no se revierten desde aquí. Gestiona la devolución en Mercado Pago.',
  dues_exemption_not_found: 'Ese mes no está marcado como exento.',
  dues_online_payment_disabled: 'El pago en línea no está habilitado para esta organización.',
  dues_online_payment_not_connected: 'La organización no tiene una cuenta de Mercado Pago conectada.',
  dues_online_payment_failed: 'No se pudo iniciar el pago en línea. Intenta nuevamente.',
}

export function duesErrorMessage(error: unknown, fallback = 'No se pudo completar la operación.'): string {
  const message =
    typeof error === 'object' && error !== null && 'message' in error
      ? String((error as { message: unknown }).message)
      : ''
  const code = Object.keys(DUES_ERROR_MESSAGES).find((key) => message.includes(key))
  return (code && DUES_ERROR_MESSAGES[code]) || fallback
}
